module.exports = __webpack_public_path__ + "img/gushi-bg.73706a79.jpg";